import { createStore } from 'vuex'
import { popupKeyData, maxName, minName } from './key'

function createPopupNameState() {
  const state = {}
  Object.values(popupKeyData).forEach((value) => {
    state[`${value}Visible`] = false
    state[`${value}MinVisible`] = false
  })
  return state
}

// z-index 上限：保证弹窗层级始终低于 Element Plus 全局组件（ElMessage 等默认 2000+）。
const POPUP_Z_INDEX_MIN = 1500
const POPUP_Z_INDEX_MAX = 1999

function nextPopupZIndex(state) {
  if (state.popupZIndex < POPUP_Z_INDEX_MAX) {
    state.popupZIndex += 1
  }
}

export default createStore({
  state: {
    ...createPopupNameState(),
    popupCount: 0, //可拖拽弹窗显示个数
    popupZIndex: POPUP_Z_INDEX_MIN, // 当前最高弹窗层级（上限 1999，避免与 EP 冲突）
    activePopupKey: '' // 最近一次被激活/打开的弹窗 key
  },
  mutations: {
    popupOpen(state) {
      state.popupCount += 1
    },
    popupClose(state) {
      if (state.popupCount <= 0) {
        return
      }
      state.popupCount -= 1
    },
    // 可拖拽弹窗的 z-index；支持记录当前被激活的弹窗 key。
    changePopupZIndex(state, key = '') {
      nextPopupZIndex(state)
      if (key) {
        state.activePopupKey = key
      }
    },
    // 打开可拖拽弹窗；即使弹窗已存在，也要记录这次激活的是谁，供组件同步置顶。
    openPopupVisible(state, key) {
      if (!Object.prototype.hasOwnProperty.call(popupKeyData, key)) {
        console.error('无效的 key')
        return
      }
      // 先校验 key，再递增层级，避免非法 key 污染全局 z-index 状态。
      nextPopupZIndex(state)
      state.activePopupKey = key
      const max = maxName(key)
      const min = minName(key)
      if (state[min]) {
        state[min] = false
      }
      if (!state[max]) {
        state[max] = true
      }
    },
    //关闭可拖拽弹窗
    closePopupVisible(state, payload) {
      const { key, type = 'max' } = payload
      if (!Object.prototype.hasOwnProperty.call(popupKeyData, key)) {
        console.error('无效的 key')
        return
      }
      if (type === 'min') {
        state[minName(key)] = true
        return
      }
      state[maxName(key)] = false
      // 关闭弹窗时同步清理最小化状态，避免 minVisible 残留为 true。
      state[minName(key)] = false
      if (state.activePopupKey === key) {
        state.activePopupKey = ''
      }
    }
  },
  actions: {},
  modules: {}
})
